"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledVisualizerRatioBox = exports.StyledVisualizer = exports.StyledImage = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _RatioBox = _interopRequireDefault(require("../RatioBox/RatioBox.index"));

var _templateObject, _templateObject2;

var StyledVisualizer = _styledComponents["default"].section.withConfig({
  displayName: "ErrorVisualizerstyles__StyledVisualizer",
  componentId: "sc-13cmj71-0"
})(["height:fit-content;transition:position 0.3s ease-in-out,top 0.2s linear,width 0.3s ease-in-out;"]);

exports.StyledVisualizer = StyledVisualizer;
var StyledVisualizerRatioBox = (0, _styledComponents["default"])(_RatioBox["default"]).withConfig({
  displayName: "ErrorVisualizerstyles__StyledVisualizerRatioBox",
  componentId: "sc-13cmj71-1"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["br2-l shadow-1-ns h-100 flex flex-wrap flex-row flex-column-ns items-center justify-center tc overflow-hidden static"]))));
exports.StyledVisualizerRatioBox = StyledVisualizerRatioBox;

var StyledImage = _styledComponents["default"].img.withConfig({
  displayName: "ErrorVisualizerstyles__StyledImage",
  componentId: "sc-13cmj71-2"
})(["", ""], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["h-100"]))));

exports.StyledImage = StyledImage;